import { useState } from "react";
import { toast } from "sonner";
import { FormPage, TextField, AreaField, SelectField, SubmitButton, SuccessPanel } from "@/components/forms";
import { api, apiError } from "@/lib/api";

const EMPTY = {
  name: "",
  email: "",
  phone: "",
  role_interest: "",
  experience: "",
  referral_source: "",
};

export default function Apply() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/forms/application", form);
      setSent(true);
      toast.success("Application sent — thank you for your interest.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <FormPage
      testid="apply-page"
      eyebrow="Careers at Homevia"
      lines={["Introduce", "yourself."]}
      intro="Tell us who you are and the kind of role you're drawn to. When a fitting opening appears, you'll be the first to know."
      asideTitle="No published openings?"
      asideText="That's okay — we keep every thoughtful introduction on file and reach out when the right role appears."
    >
      {sent ? (
        <SuccessPanel
          testid="apply-success"
          title="Application received"
          message="Thank you for your interest in Homevia. We'll be in touch when a fitting opportunity opens up."
          onReset={() => {
            setForm(EMPTY);
            setSent(false);
          }}
        />
      ) : (
        <form onSubmit={onSubmit} data-testid="apply-form" className="space-y-6">
          <div className="grid gap-6 sm:grid-cols-2">
            <TextField id="ap-name" label="Full name" required value={form.name} onChange={set("name")} />
            <SelectField
              id="ap-role"
              label="Role of interest"
              required
              value={form.role_interest}
              onChange={set("role_interest")}
              options={["Nursing", "Caregiving / home support", "Care coordination", "Administrative", "Other"]}
            />
          </div>
          <div className="grid gap-6 sm:grid-cols-2">
            <TextField id="ap-email" label="Email" type="email" required value={form.email} onChange={set("email")} />
            <TextField id="ap-phone" label="Phone" type="tel" required value={form.phone} onChange={set("phone")} />
          </div>
          <AreaField
            id="ap-experience"
            label="Your experience"
            required
            value={form.experience}
            onChange={set("experience")}
            placeholder="A short summary of your background and the kind of work you're looking for."
          />
          <TextField
            id="ap-source"
            label="How did you hear about Homevia? (optional)"
            value={form.referral_source}
            onChange={set("referral_source")}
          />
          <SubmitButton loading={loading} testid="apply-submit-btn">
            Send Application
          </SubmitButton>
        </form>
      )}
    </FormPage>
  );
}
